import { on } from '../helpers/shortcuts';
import S from './shared';

export default () => {
  const readMore = document.querySelectorAll('.c-read-more__more');

  if (readMore.length < 1) {
    return;
  }

  on('click', readMore, event => {
    event.preventDefault();
    event.currentTarget.previousElementSibling.classList.add(S.CSS.visible);
    event.currentTarget.nextElementSibling.classList.add(S.CSS.visible);
    event.currentTarget.classList.add(S.CSS.hidden);
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/read-more.js